import { defineTheme } from '../utils'

export const byzoo = defineTheme({
  themeLogo: {
    image: 'h-46 w-46 bg-[url(/images/logos/byzoo.svg)] bg-contain bg-center bg-no-repeat object-contain',
  },
  menuTitleBlock: {
    title: 'text-center font-heading text-6xl text-secondary',
  },
  languageButton: {
    base: 'rounded-sm bg-white p-2 text-black',
  },
  menuCategory: {
    title: 'font-heading text-4xl font-normal',
    description: 'font-bold text-secondary italic',
  },
  menuItem: {
    dinner: {
      base: 'dinner-base grid grid-cols-[1fr_auto] items-start gap-1',
      title: 'dinner-title text-xl font-bold text-secondary',
      description: 'dinner-description order-2 col-span-2 text-sm text-white',
      priceList: 'text-right text-secondary',
      icons: 'order-4 col-span-2',
      label: 'dinner-label order-3 col-span-2 mb-1 bg-white p-2 font-base text-sm font-medium text-black italic',
    },
    drinks: {
      base: 'grid grid-cols-[1fr_auto] items-start gap-1',
      title: 'text-xl font-bold text-secondary',
      description: 'order-2 col-span-2 text-sm text-white',
      priceList: 'text-right text-secondary',
      icons: 'order-4 col-span-2',
      label: 'order-3 col-span-2 mb-1 bg-tertiary p-2 font-base text-sm font-medium text-black italic',
    },
  },
  menuSubCategory: {
    base: 'grid gap-4',
    title: '-mb-3 text-xl font-bold text-white',
    description: 'mt-3 -mb-3 italic',
  },
  menuTextBlock: {
    base: 'border-3 border-secondary p-4 italic',
  },
  page: {
    heading: 'font-heading text-7xl uppercase',
    menuHeading: '',
  },
  filterBar: {
    bar: 'bg-secondary text-white',
    barTitle: '',
    checkbox: ' accent-white',
    closeButton: 'bg-primary text-white hover:bg-primary/60',
    masterItem: 'text-black',
    itemLabel: 'text-white',
    popoverTitle: 'text-white',
    popover: 'bg-primary',
    popoverHeader: 'bg-secondary',
  },
})
